import React from "react";

import { Row, Col, Container } from "react-bootstrap";







const PrivacyPolicy = () => {
  return (
    <>
      <header class="masthead subPageHead data-cloud-header dataCloudBanner privacy-policy">
        <div class="container">
          <Row className="justify-content-center">
            <Col xl={12} lg={12}>
              {/* <Image src={shape3} className='shape3 d-none d-md-block' /> */}
              <div class="masthead-heading text-white text-center pt-5 pb-5">
                Privacy{" "}
                <span className="fancy-text4 ps-1 pe-2 mb-0  z-0 text-EE0000  position-relative overflow-hiddens text-white">
                  Policy{" "}
                </span>
              </div>
              {/* <Image src={shape4} className='shape4 d-none d-md-block' />
                            <Image src={shape5} className='shape5 d-none d-md-block' /> */}
            </Col>
          </Row>
        </div>
      </header>

      <section class="page-section bg-white pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-3">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-center">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text">Introduction</span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-center justify-content-center">
            <Col lg={12} md={12} className="d-flex mb-2 mb-lg-0">
              <p className="fw-400 fs-6  ls-minus-02 text-252B42">
                {" "}
                Comsense Technologies (“Comsense”, “we”, “our”, or “us”) is
                committed to protecting your personal data and your privacy.
                This Privacy Policy explains how we collect, use, disclose, and
                safeguard your information when you interact with us, including
                through our website, digital campaigns (such as LinkedIn lead
                forms), marketing communications, and events.  By sharing your
                information with us, you agree to the terms outlined in this
                Privacy Policy. 
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Who We Are
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="d-flex mb-2 mb-lg-0">
              <p className="fw-400 fs-6  ls-minus-02 text-252B42">
                {" "}
                Comsense is a technology consulting firm that specializes in
                Martech, data engineering, analytics, AI, and Salesforce
                platform implementation. We work closely with clients and
                partners to build connected, personalized digital experiences
                powered by data. 
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-start fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    What Information We Collect
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="ls-minus036 fs-6 mb-1 fw-400">
                We may collect the following types of personal information from
                you:
              </p>
              <ul className="ps-2 mb-4 custom-ul">
                <li className="ls-minus036 fs-12 mb-1 fw-400">Full name</li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Job title and company name
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Business email address
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">Phone number</li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  LinkedIn profile (if shared)
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Industry and professional interests
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Event participation details (e.g. registration, feedback)
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Marketing preferences
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  IP address and browser/device info (if interacting with our
                  website or ads)
                </li>
                <p className="ls-minus036 fs-6 mb-1 fw-400 mt-4 mb-4">
                  This information may be collected when you:
                </p>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Fill out a form on LinkedIn or our website
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Register for an event or webinar
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Download resources (e.g., brochures, whitepapers)
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Interact with our content, emails, or website
                </li>
              </ul>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-start fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    How We Use Your Information 
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="ls-minus036 fs-6 mb-1 fw-400">
                We use your information to: 
              </p>
              <ul className="ps-2 mb-4 custom-ul">
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Respond to your inquiries or requests 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Send you relevant content, updates, or invitations 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Improve your experience with our communications 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Personalize marketing outreach and sales interactions 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Conduct analytics and optimize campaign performance 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Fulfill legal or compliance obligations 
                </li>
                <p className="ls-minus036 fs-6 mb-1 fw-400 mb-4">
                  You may opt out of communications from us at any time. 
                </p>
              </ul>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-start fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Legal Basis for Processing 
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="ls-minus036 fs-6 mb-1 fw-400">
                Depending on your location and applicable laws (such as GDPR),
                we rely on one or more of the following legal bases to process
                your personal data: 
              </p>
              <ul className="ps-2 mb-4 custom-ul">
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Your explicit consent (e.g., opting into communications) 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Our legitimate interest (e.g., marketing to professionals
                  likely to benefit from our services) 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Contractual necessity (e.g., event or content fulfillment) 
                </li>
              </ul>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-start fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Sharing of Your Information  
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="ls-minus036 fs-6 mb-3 fw-400">
                We do not sell your personal information. 
              </p>
              <p className="ls-minus036 fs-6 mb-1 fw-400">
                We may share it with: 
              </p>
              <ul className="ps-2 mb-0 custom-ul">
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Authorized internal teams (marketing, sales, events) 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Trusted partners and service providers (e.g., CRM systems,
                  marketing platforms) 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Event co-hosts or collaborators (with notice) 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Legal authorities when required by law 
                </li>
              </ul>
              <p className="ls-minus036 fs-6 mb-1 fw-400">
                All third-party processors are bound by confidentiality and data
                protection agreements. 
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-start fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Cookies and Tracking 
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="d-flex mb-2 mb-lg-0">
              <p className="fw-400 fs-6  ls-minus-02 text-252B42">
                Our website and digital content may use cookies and tracking
                technologies (e.g., LinkedIn Insight Tag, Google Analytics) to
                understand user behavior, improve content, and serve relevant
                ads.  You can manage cookie preferences in your browser
                settings. Some third-party platforms may also allow you to opt
                out of tracking. 
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-start fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Data Retention and Protection 
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="fw-400 fs-6 mb-0 ls-minus-02 text-252B42">
                We retain your personal information only for as long as needed
                to fulfill the purposes outlined in this policy, unless a longer
                retention period is required by law. 
              </p>
              <p className="fw-400 fs-6  ls-minus-02 text-252B42">
                We take appropriate technical and organizational measures to
                protect your data, including secure storage, limited access, and
                encrypted systems when applicable.  
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Your Rights
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="ls-minus036 fs-6 mb-3 fw-400">
                You have the right to: 
              </p>
              <ul className="ps-2 mb-0 custom-ul">
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Access the personal data we hold about you 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Request corrections or updates 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Withdraw consent at any time  
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Request deletion (where applicable) 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  Opt out of communications 
                </li>
                <li className="ls-minus036 fs-12 mb-1 fw-400">
                  File a complaint with your local data protection authority 
                </li>
              </ul>
              <p className="ls-minus036 fs-6 mb-0 mt-3 fw-400">
                To exercise your rights, please contact us using the details
                below. 
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Policy Updates 
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="fw-400 mb-0 fs-6 mb-0 ls-minus-02 text-252B42">
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page with a revised “Last Updated” date.
                Continued interaction with us indicates your acceptance of the
                updated policy. 
              </p>
            </Col>
          </Row>

          <Row className="align-items-center mb-3 mt-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text bordered-text-start bordered-text-100px">
                    Contact Us  
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="mt-4 text-left">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="fw-400 mb-0 fs-6 mb-3 ls-minus-02 text-252B42">
                For any questions about this Privacy Policy or your data, you
                can reach us at:  
              </p>
              <p className="fw-400 mb-0 fs-6 mb-0 ls-minus-02 text-252B42">
                Email:{" "}
                <a
                  className="text-decoration-none"
                  style={{ color: "#028bc6" }}
                  href="mailto:connect@comsenseconsulting.com"
                >
                  connect@comsenseconsulting.com
                </a>
              </p>
              <p className="fw-400 mb-0 fs-6 mb-0 ls-minus-02 text-252B42">
                Address:  7th Floor Property bearing No.465/E1, Park Plaza,
                IndiQube, CTS-1085, Ganeshkhind Rd, Shivajinagar, Pune,
                Maharashtra 411005, India
              </p>
              <p className="fw-400 mb-0 fs-6 mb-0 ls-minus-02 text-252B42">
                Website:{" "}
                <a
                  className="text-decoration-none"
                  style={{ color: "#028bc6" }}
                  href="www.comsensetechnologies.com"
                >
                  www.comsensetechnologies.com
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
